<template>
  <div class="language" :class="$store.state.theme">
    <div class="modal language-modal">
      <div class="modal-background" @click="closeModal"></div>
      <button
        class="modal-close is-large"
        aria-label="close"
        @click="closeModal"
      ></button>
      <div class="modal-card">
        <section class="modal-card-body">
          <p class="title">{{ $t("choose-language") }}</p>
          <div class="wrapper">
            <div class="columns is-mobile">
              <div class="column" @click="changeLang('th')">
                <p><button class="button is-primary">TH</button></p>
                <p>ภาษาไทย</p>
              </div>
              <div class="column" @click="changeLang('en')">
                <p><button class="button is-primary">EN</button></p>
                <p>English</p>
              </div>
              <div class="column" @click="changeLang('ja')">
                <p><button class="button is-primary">JA</button></p>
                <p>日本語</p>
              </div>
            </div>
            <!-- <div class="columns is-mobile">
              <div class="column" @click="changeLang('zh')">
                <p>汉语</p>
              </div>
              <div class="column" @click="changeLang('my')">
                <p>မြန်မာစာ</p>
              </div>
              <div class="column" @click="changeLang('km')">
                <p>ភាសាខ្មែរ</p>
              </div>
            </div> -->
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
// import EventBus from "../eventBus.js";

export default {
  name: "LanguageModal",
  data() {
    return {};
  },
  mounted() {
    this.$store.subscribe((mutation) => {
      if (mutation.type === "setLanguage") this.closeModal();
    });
  },
  methods: {
    closeModal() {
      this.inputCode = "";
      this.error = "";
      this.$el.querySelector(".modal").classList.remove("is-active");
      this.geolocationRequestModal();
      this.updateLocation();
    },
    changeLang(language) {
      this.setLang(language, true);
      if (this.$store.getters.isLoggedIn) {
        this.$store.dispatch("setLanguage", language);
      }
      setTimeout(() => this.closeModal(), 700);
      this.geolocationRequestModal();
      this.updateLocation();
    },
  },
};
</script>

<style scoped>
.modal-card-body {
  max-width: 500px;
  /* border-radius: 25px; */
  padding-right: 15px;
  padding-left: 15px;
  padding-top: 12px;
}
.wrapper {
  /*background-color: rgb(245, 245, 245);*/
}
.title {
  /* text-align: left; */
  font-size: 1.4em;
  font-weight: 500;
  color: #555;
  margin-top: 6px;
}
.columns {
  /* background-color: whitesmoke;
  border-radius: 5px; */
  font-size: 1.2em;
}
.column:active {
  transform: scale(0.95);
}
.button {
  margin-bottom: 10px;
}

/* ---- modern refresh: rounded card, yellow language chips, follows the light/dark toggle ---- */
.modal-background {
  background-color: rgba(31, 27, 36, 0.5);
  -webkit-backdrop-filter: blur(6px);
  backdrop-filter: blur(6px);
}

.modal-card {
  width: calc(100vw - 32px);
  max-width: 460px;
  overflow: visible;
}

.modal-card-body {
  border-radius: 28px;
  padding: 24px 16px 14px;
  background-color: #fff;
  color: #1f1b24;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.35);
}

.dark .modal-card-body {
  background-color: #1b1822;
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.title {
  margin-bottom: 18px;
  font-size: 1.35em;
  font-weight: 800;
  letter-spacing: -0.01em;
  color: #1f1b24;
}

.dark .title {
  color: #fff;
}

.columns {
  margin: 0;
  gap: 8px;
}

.column {
  padding: 14px 6px 12px;
  border-radius: 20px;
  background-color: rgba(31, 27, 36, 0.04);
  cursor: pointer;
  transition: transform 0.15s ease, background-color 0.15s ease;
}

.column:hover {
  background-color: rgba(255, 200, 0, 0.18);
}

.dark .column {
  background-color: rgba(255, 255, 255, 0.06);
}

.dark .column:hover {
  background-color: rgba(255, 255, 255, 0.12);
}

.button.is-primary {
  min-width: 64px;
  height: 2.5em;
  border: 0;
  border-radius: 999px;
  font-weight: 800;
  letter-spacing: 0.04em;
  color: #1f1b24;
  background: linear-gradient(180deg, #ffd84a 0%, #ffc800 100%);
  box-shadow: 0 8px 18px rgba(255, 190, 0, 0.35);
}

.column p:last-child {
  font-weight: 600;
  color: #3b3b44;
}

.dark .column p:last-child {
  color: #e9e9ef;
}
</style>
